import axiosInstance from "../../services/API";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const submitSupportTicket = createAsyncThunk(
    "submitSupportTicket",
    async (ticketData, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/support/submit/`, ticketData);
            return response.data;
        } catch (error) {
            const data = error.response?.data;
            if (data?.errors) {
                const first = Object.values(data.errors)[0];
                return rejectWithValue(Array.isArray(first) ? first[0] : first);
            }
            return rejectWithValue(data?.message || "Something went wrong. Please try again later.");
        }
    }
);

export const submitFeedBack = createAsyncThunk(
    "submitFeedBack",
    async (feedbackData, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/help/submit-feedback/`, feedbackData);
            const result = response.data;
            return result;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const subscribe = createAsyncThunk("subscribe", async (email, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/help/subscribe/`, { email });
        const result = response.data;
        return result;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

export const HelpSlice = createSlice({
    name: "help",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        // submitSupportTicket
        builder.addCase(submitSupportTicket.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(submitSupportTicket.fulfilled, (state) => {
            state.loading = false;
            state.error = null;
        });
        builder.addCase(submitSupportTicket.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || action.error.message;
        });

        // submitFeedBack
        builder.addCase(submitFeedBack.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(submitFeedBack.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.data;
            state.error = null;
        });
        builder.addCase(submitFeedBack.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || action.error.message;
        });

        // subscribe
        builder.addCase(subscribe.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(subscribe.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.data;
            state.error = null;
        });
        builder.addCase(subscribe.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || action.error.message;
        });
    },
});

export default HelpSlice.reducer;